module.exports = __webpack_public_path__ + "img/waive-description-1.fdbdedae.webp";